import { z } from 'zod';

import type { ApiInterface } from '../../utilities/ApiInterface';
import type { Api } from '@automapa/svelte-automapa-template';

export const ExportRequestSchema = z.object({
    type: z.string(),
});
export type ExportRequestType = z.infer<typeof ExportRequestSchema>;

export const ExportResponseSchema = z.any();
export type ExportResponseType = z.infer<typeof ExportResponseSchema>;

export class ExportApi implements ApiInterface {
    private static _endpoint: string = 'export';

    static async getFile(
        api: Api,
        endpoint_method: string,
        settings: {
            type: string;
            import_id?: number;
            sort_by_zone?: string;
            scenario_id?: number;
            assignment_ids?: number[];
        }
    ): Promise<any> {
        return api.getData<any, any>(
            'post',
            `/${this._endpoint}/${endpoint_method}`,
            settings,
            z.any(),
            z.any(),
            'blob'
        );
    }

    static async getFileAsText(
        api: Api,
        endpoint_method: string,
        settings: {
            type: string;
            import_id?: number;
            sort_by_zone?: string;
            scenario_id?: number;
            assignment_ids?: number[];
        }
    ): Promise<string> {
        const blob = await api.getData<any, Blob>(
            'post',
            `/${this._endpoint}/${endpoint_method}`,
            settings,
            z.any(),
            z.any(),
            'blob'
        );
        return blob.text();
    }
}
